import React, { useState } from "react";
import {
    Select, MenuItem, FormControl, Box,
    RadioGroup, FormControlLabel, Radio,
    Typography, useTheme, useMediaQuery
} from "@mui/material";
import PoliciesList from "../../notes/PoliciesList";

const GlobalNotes = ({
    selected_customer_list,
    customerId,
    setSearchPerformed
}) => {
    const [selectedPolicyId, setSelectedPolicyId] = useState("");
    const [selectedOption, setSelectedOption] = useState("All");
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleDropdownChange = (event) => {
        setSelectedPolicyId(event.target.value);
    };

    const handleRadioChange = (event) => {
        const newOption = event.target.value;
        setSelectedOption(newOption);

        if (newOption === "All") {
            setSelectedPolicyId("");
        }
    };

    return (
        <>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 2,
                mx: { xs: 1, sm: 2, md: 3 }, 
                flexWrap: 'wrap' 
            }}>
                <RadioGroup
                    row={!isMobile} 
                    value={selectedOption}
                    onChange={handleRadioChange}
                    sx={{
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: { xs: 0, sm: 1 }
                    }}
                >
                    <FormControlLabel
                        value="All"
                        control={<Radio size={isMobile ? "small" : "medium"} />}
                        label={<Typography variant={isMobile ? "body2" : "body1"}>All</Typography>}
                    />
                    <FormControlLabel
                        value="Policies"
                        control={<Radio size={isMobile ? "small" : "medium"} />}
                        label={<Typography variant={isMobile ? "body2" : "body1"}>Policies</Typography>}
                    />
                </RadioGroup>
            </Box>

            {selectedOption === "Policies" && (
                <Box sx={{
                    display: 'flex',
                    px: { xs: 1, sm: 2, md: 3 }, 
                    mb: 2
                }}>
                    <FormControl
                        fullWidth
                        sx={{
                            maxWidth: {
                                xs: '100%',      
                                sm: '300px',     
                                md: '350px',     
                                lg: '400px'     
                            }
                        }}
                    >
                        <Typography
                            variant={isMobile ? "body2" : "body1"}
                            sx={{
                                mb: 1,
                                fontWeight: 500,
                                fontSize: { xs: '0.875rem', sm: '1rem' }
                            }}
                        >
                            Select Policy
                        </Typography>
                        <Select
                            value={selectedPolicyId}
                            onChange={handleDropdownChange}
                            size={isMobile ? "small" : "medium"}
                            sx={{
                                fontSize: { xs: '0.875rem', sm: '1rem' },
                                '& .MuiSelect-select': {
                                    py: { xs: 1, sm: 1.5 } 
                                }
                            }}
                        >
                            {selected_customer_list.map((policy) => (
                                <MenuItem
                                    key={policy.id}
                                    value={policy.id}
                                    sx={{
                                        fontSize: { xs: '0.875rem', sm: '1rem' },
                                        py: { xs: 0.75, sm: 1 }
                                    }}
                                >
                                    {policy.policyNumber}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            )}

            <PoliciesList
                selectedOption={selectedOption}
                selectedPolicyId={selectedPolicyId}
                setSearchPerformed={setSearchPerformed}
                customerId={customerId}
                selected_customer_list={selected_customer_list}
            />
        </>
    );
}

export default GlobalNotes;